export const setList = (state, payload) => (state.list = payload)
